export default __webpack_public_path__ + "static/media/Bird31.cc09ea9f.png";